React = require 'react'
userStore = require 'stores/user'
createReactClass = require 'create-react-class'
ReactBacon = require 'react-bacon'
{ BaconMixin } = ReactBacon
{ Route, Redirect, withRouter } = require 'react-router-dom'
Welcome = require './welcome.coffee'

PrivateRoute = createReactClass
  displayName: 'PrivateRoute'
  mixins: [BaconMixin]

  getInitialState: ->
    loggedIn: false

  componentWillMount: ->
    @plug userStore.loggedIn, 'loggedIn'

  render: ->
    <Route exact = {@props.exact} path = {@props.path} render={(props) =>
      if @state.loggedIn
        Comp = @props.component
        if Comp then <Comp {...@props} /> else @props.children
      else
        <Welcome/>
      } />


module.exports = PrivateRoute
